import React from "react";

export function detailCells(DataCell) {
    return { data: DataCell };
}

export function DetailGridTextCell(props) {
    const value = props.dataItem?.[props.field];
    const display = value != null && value !== "" ? String(value) : "";
    const { tdProps } = props;
    return <td className={`${tdProps.className} p-2`}>{display}</td>;
}

export function DetailHierarchySpacerCell() {
    return <td className="" aria-hidden="true" />;
}

export function BankRecHierarchyCell(props) {
    const { dataItem, tdProps, children } = props;
    if (dataItem?.isGroupParent) {
        return <td {...tdProps}>{children}</td>;
    }
    return <td {...tdProps} />;
}
